import 'react-app-polyfill/ie11';

import React, { createRef } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import FooterCCDMD from './components/FooterCCDMD/FooterCCDMD';

/* eslint-disable */
if(!Array.prototype.includes){
  // Fonction polyfill pour Internet Explorer
  Array.prototype.includes = function(search){
   return !!~this.indexOf(search);
 }
}
/* eslint-enable */

var footerRef = createRef<FooterCCDMD>();

const app_root = ReactDOM.createRoot(
  document.getElementById('laby-app') as HTMLElement
);
const app_footer = ReactDOM.createRoot(
  document.getElementById('ccdmd_footer') as HTMLElement
);

app_root.render(
  <React.StrictMode>
    <App footerRef={footerRef} />
  </React.StrictMode>
);

app_footer.render(
  <React.StrictMode>
    <FooterCCDMD ref={footerRef} />
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
